import React from "react";

export const IconLibrary = () => {
    return (
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M19.5 2.75H6.75C5.95435 2.75 5.19129 3.06607 4.62868 3.62868C4.06607 4.19129 3.75 4.95435 3.75 5.75V21.5C3.75 21.6989 3.82902 21.8897 3.96967 22.0303C4.11032 22.171 4.30109 22.25 4.5 22.25H18C18.1989 22.25 18.3897 22.171 18.5303 22.0303C18.671 21.8897 18.75 21.6989 18.75 21.5C18.75 21.3011 18.671 21.1103 18.5303 20.9697C18.3897 20.829 18.1989 20.75 18 20.75H5.25C5.25 20.3522 5.40804 19.9706 5.68934 19.6893C5.97064 19.408 6.35218 19.25 6.75 19.25H19.5C19.6989 19.25 19.8897 19.171 20.0303 19.0303C20.171 18.8897 20.25 18.6989 20.25 18.5V3.5C20.25 3.30109 20.171 3.11032 20.0303 2.96967C19.8897 2.82902 19.6989 2.75 19.5 2.75ZM18.75 17.75H6.75C6.22326 17.7493 5.70572 17.888 5.25 18.1522V5.75C5.25 5.35218 5.40804 4.97064 5.68934 4.68934C5.97064 4.40804 6.35218 4.25 6.75 4.25H18.75V17.75Z"
                fill="#08212D"
            />
        </svg>
    );
};
